"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const setting_layout_wrapper_1 = require("../../setting-layout-wrapper");
const security_1 = require("../../../../icon/security");
const setting_item_wrapper_1 = require("../../setting-item-wrapper");
const update_password_layout_1 = require("./update-password-layout");
exports.SecurityLayout = (0, react_1.memo)(() => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(setting_layout_wrapper_1.SettingLayoutWrapper, { title: "Security Settings", description: "Manage your account security and protect your personal information.", icon: security_1.SecurityIcon, children: (0, jsx_runtime_1.jsx)(material_1.Paper, { sx: {
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                position: "relative",
                bgcolor: "#fff",
                borderRadius: theme.spacing(2),
                boxShadow: theme.shadows[2],
                overflow: "hidden",
                padding: theme.spacing(2),
            }, children: (0, jsx_runtime_1.jsx)(setting_item_wrapper_1.SettingItemWrapper, { title: "Password", description: "Change your account password regularly to keep your account secure.", divier: false, children: (0, jsx_runtime_1.jsx)(update_password_layout_1.UpdatePasswordLayout, {}) }) }) }));
});
exports.SecurityLayout.displayName = "SecurityLayout";
